import { stat } from "fs/promises";
import HmsVideocallManager from "../../util/100ms/HmsVideocallManager";
import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import MedicalEmergencyService from "../medical-emergency/medical-emergency.service";
import { MedicalEmergencyType } from "./MedicalEmergencyType";
import { PassengerType } from "./typings/PassengerType";
import { PassengersType } from "../../components/main/body/screens/IAM/Passengers/PassengersType";
import { OrganizationType } from "../../components/main/body/screens/IAM/Users/types/OrganizationType";


interface QueAnsObject {
  queAns: {
    [key: number]: string;
  };
  passengerId: number; // passengerId as a number
}
export default class PassengerService {
  static async getPassenger(id: number) {
    const apiConfig = {
      api: APIs.Passenger.GetPassenger,
      parameters: {
        "passenger-id": id
        
        
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data as PassengerType | null;
  };
 
  static async listAllPassenger(orgId?: number):Promise<PassengerType[]> {
    const apiConfig = {
      api: APIs.Passenger.ListPassenger,
      parameters: {
        organizationId: orgId ?? ""
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }

  // static createPassengerAndEmergency = async (
  //   passenger: {
  //     name?: string;
  //     age?: string;
  //     gender?: string;
  //   },
  //   medicalEmergency: MedicalEmergencyType,
  // ) => {
  //   try {
  //     let gender = 'OTHERS';
  //     if (passenger.gender) {
  //       if (passenger.gender.toLocaleLowerCase() === 'male') {
  //         gender = 'MALE';
  //       } else if (passenger.gender.toLocaleLowerCase() === 'female') {
  //         gender = 'FEMALE';
  //       } else {
  //         gender = 'OTHERS';
  //       }
  //     }
  //     // alert(JSON.stringify(gender));

  //     const passengerRes = await MedicalEmergencyService.createPassenger(
  //         passenger.name ?? '',
  //         parseInt(passenger.age ?? '0', 10),
  //         gender
  //       );
  //     // alert(JSON.stringify(passengerRes));
  //     console.log("passenger",passengerRes.data);

  //     let status = passengerRes.status;
  //     console.log("passenger status", status);

  //     if (status === 202 ) {
  //       console.log("passenger data",passengerRes.data);
  //       const params = {
  //               passengerId: passengerRes.data.id,
  //               symptoms: medicalEmergency.symptoms.join(','),
  //               status: medicalEmergency.status, // NOTIFIED, MONITORING, RESOLVED, EMERGENCY_CARE_REQUIRED, CONTINUE_WITHOUT_CONTACT
  //               flightId: medicalEmergency.flightId,
  //               createdBy: medicalEmergency.createdBy,
  //               treatmentsGiven: medicalEmergency.treatmentsGiven,
  //               passengerStatusQuestions: medicalEmergency.passengerStatusQuestions,
  //               crewNotes: medicalEmergency.crewNotes,
  //             };

  //       const medicalEmergencyRes = await MedicalEmergencyService.createMedicalEmergency(params);
  //       // alert(JSON.stringify(medicalEmergencyRes));
  //       console.log("medicalEmergencyRes",medicalEmergencyRes);

  //       const room = await HmsVideocallManager.createRoom();
  //       console.log("room", room);
  //       const roomId = `${room.id},${room.name}`;
  //       console.log("roomId",roomId);

  //       const captainRoom = await HmsVideocallManager.createRoom();
  //       console.log("captainRoom", captainRoom);
  //       const captainRoomId = `${captainRoom.id},${captainRoom.name}`;
  //       console.log("captainRoomId",captainRoomId);

  //       if (roomId && captainRoomId || roomId || captainRoomId || true) {
  //         let videoCallRecord = await MedicalEmergencyService.createVideoCall(medicalEmergencyRes.id, roomId, captainRoomId, 'INITIATED');
  //         console.log("videoCallRecord", videoCallRecord);
  //       }
  //       return medicalEmergencyRes;
  //     }
  //   } catch (e) {
  //     console.log(e);
  //     alert('Error occured while creating passenger or me');
  //   }
  // };


  static createPassengerAndEmergency = async (
    passenger: {
      org: string,
      name?: string;
      age?: string;
      gender?: string;
    },
    medicalEmergency: MedicalEmergencyType,
    passengerId: number | null,
    patienConsciousStatus: boolean
  ) => {
    try {
      let gender = 'OTHERS';
      if (passenger.gender) {
        gender = passenger.gender.toLocaleLowerCase() === 'male' ? 'MALE' : passenger.gender.toLocaleLowerCase() === 'female' ? "FEMALE" : "OTHERS";
      }
      let passengerRes;
      if (passengerId == null) {
        [passengerRes] = await Promise.all([
            MedicalEmergencyService.createPassenger(passenger.org,passenger.name ?? '',parseInt(passenger.age ?? '0', 10),gender)
        ]);
      }

      const [room, captainRoom] = await Promise.all([
        HmsVideocallManager.createRoom(),
        HmsVideocallManager.createRoom()
    ]);

    // const room = await HmsVideocallManager.createRoom();
      
      console.log("passenger",passengerRes?.data);
      let status = passengerRes?.status;
      if (status === 202 ||  passengerId) {
        console.log("passenger data",passengerRes?.data);
        if (passengerRes?.data.id || passengerId) {
        const params = {
                passengerId: passengerRes?.data.id || passengerId,
                symptoms: medicalEmergency.symptoms.join(','),
                status: medicalEmergency.status, // NOTIFIED, MONITORING, RESOLVED, EMERGENCY_CARE_REQUIRED, CONTINUE_WITHOUT_CONTACT
                flightId: medicalEmergency.flightId,
                createdBy: medicalEmergency.createdBy,
                assignedCrew: medicalEmergency.assignedCrew,
                treatmentsGiven: medicalEmergency.treatmentsGiven,
                passengerStatusQuestions: medicalEmergency.passengerStatusQuestions,
                crewNotes: medicalEmergency.crewNotes,
                isPatientConsious: patienConsciousStatus
              };
        const medicalEmergencyRes = await MedicalEmergencyService.createMedicalEmergency(params);
        console.log("medicalEmergencyRes",medicalEmergencyRes);

        let videoCallRecord = await MedicalEmergencyService.createVideoCall(medicalEmergencyRes.id, `${room.id},${room.name}`, `${captainRoom.id},${captainRoom.name}`, 'INITIATED');
        // let videoCallRecord = await MedicalEmergencyService.createVideoCall(medicalEmergencyRes.id, `${room.id},${room.name}`, 'INITIATED');
        console.log("videoCallRecord", videoCallRecord);
        return medicalEmergencyRes;
      }
    }
    } catch (e) {
      console.log(e);
      alert('Error occured while creating passenger or me');
    }
  };

  static async getOrganizations() {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.ListAllOrganizations,
      parameters: null,
      body: {},
    });
    return response.data;
  };
  static async getOrgByUserName(name: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.OrgByUserName,
      parameters: {
        username: name
      },
      body: {},
    });
    return response.data;
  }
  // static async addPassenger( orgId: string, name : string,contactNumber: string,email : string,address:string,age:string,gender:any,physicallyDesabled:string,anychronicDisease:string,input1:string,input2:string,input3:string)  {
  //   const response = await SafeairManager.invoke({
  //     api: APIs.Passenger.CreatePassenger,
  //     parameters: null,
  //     body: {
  //       orgId: orgId,
  //       name:name,
  //       contactNumber:contactNumber,
  //       email:email,
  //       address:address,
  //       age:age,
  //       gender:gender,
  //       // seatNumber:seatNumber,
  //       // physicallyDesabled:physicallyDesabled,
  //       // anychronicDisease:anychronicDisease,
  //       // input1:input1,
  //       // input2:input2,
  //       // input3:input3,
  //       departurePlace: "PHX",
  //       arrivalPlace: null,
  //       diversionDecisionStatus: "DIVERSION_NOT_REQUIRED",
  //       schedDepTime: "2020-01-01T08:00:00+0000",
  //       schedArvTime: "2055-01-01T11:00:00+0000",
  //       actualDepTime: "2020-01-01T08:30:00+0000",
  //       actualArvTime: "2055-01-01T11:30:00+0000",
  //     },
  //   });
  //   return response.data as OrganizationType[];
  // }

  static async updatePassenger(passengerData:any)  {
    const response = await SafeairManager.invoke({
      api: APIs.Passenger.UpdatePassenger,
      parameters: null,
      body: passengerData,
    });
    return response.data;
  }

  static async addPassenger(passengerData:any) {
    const response = await SafeairManager.invoke({
      api: APIs.Passenger.CreatePassenger,
      parameters: null,
      body: {
        orgId: passengerData.orgId,
        name: passengerData.name,
        contactNumber: passengerData.contactNumber,
        email: passengerData.email,
        address: passengerData.address,
        age: passengerData.age, // Ensure age is a number
        gender: passengerData.gender,
      },
    });
    return response.data as OrganizationType[];
  }

  static async getQuestionList() {
    const response = await SafeairManager.invoke({
      api: APIs.Question.listQuestion,
      parameters: null,
      body: {},
    });
    return response.data;
  }

  static async getAnswereById(passengerId: number, questionId: number) {
    const response = await SafeairManager.invoke({
      api: APIs.Question.getAnswere,
      parameters: {
        "passenger-id": passengerId,
        "question-id": questionId
      },
      body: null,
    });
    return response.data;
  }

  static async addAnswere(data: QueAnsObject) {
    const response = await SafeairManager.invoke({
      api: APIs.Question.addAnswere,
      parameters: null,
      body: data,
    });
    return response.data;
  }
  
}
